import { useEffect, useRef } from "react";
import api from "../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) {
      window.location.href = "/admin";
      return;
    }
    (async () => {
      try {
        await api.post("/auth/session", { session_id: sessionId });
      } catch (e) {
        console.error("Auth failed", e);
      } finally {
        window.location.href = "/admin";
      }
    })();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF8F5]">
      <p className="text-[#7C897B] font-sans tracking-wide">Signing you in…</p>
    </div>
  );
}
